import { useI18n } from '@hive/i18n';
import { useMemo } from 'react';

export const useNavConfig = () => {
  const t = useI18n();
  return useMemo(
    () => [
      {
        title: t['com.hive.other-page.nav.official-website'](),
        path: 'https://hive.ai',
      },
      {
        title: t['com.hive.other-page.nav.blog'](),
        path: 'https://hive.ai/blog',
      },
      {
        title: t['com.hive.other-page.nav.contact-us'](),
        path: 'https://hive.ai/about-us',
      },
    ],
    [t]
  );
};
